import Vue from "vue";
import Vuex from "vuex";
import alert from "./alerts.module";
import router from "../router/index";
import { userService } from "../_services";

Vue.use(Vuex);
const token = window.$cookies.get('SESSION');

const store = new Vuex.Store({
  modules: {
    alert
  },
  state: {
    errors: [],
    isPlaying: false,
    openModal: false,
    name: null,
    address: {},
    minbid: null,
    highest: null,
    bids: [],
    fundaUrl: null,
    images: [],
    assets: [],
    closingDateTime: null,
    code: null,
    codeClaimed: false,
    linkedProperty: null,
    percentage: null,
    status: {loggedIn: !!token},
    user: token || null,
    callme: false,
    registering: false,
    posts: [],
    agent: [],
    properties: [],
    support: [],
    regio: [],
    review: [],
    Funnel_toelichting: []
  },
  actions: {
    saveAgent(context, data) {
      context.commit("SET_AGENT", data);
    },
    savePosts(context, data) {
      context.commit("SET_POSTS", data);
    },
    saveProperties(context, data) {
      context.commit("SET_PROPERTIES", data);
    },
    saveSupport(context, data) {
      context.commit("SET_SUPPORT", data);
    },
    saveRegio(context, data) {
      context.commit("SET_REGIO", data);
    },
    saveReview(context, data) {
      context.commit("SET_REVIEW", data);
    },
    saveFunnel_toelichting(context, data) {
      context.commit("SET_Funnel_toelichting", data);
    },
    togglePlayer(context, status) {
      context.commit("IS_PLAYING", status);
    },
    toggleModal(context, status) {
      context.commit("IS_OPEN", status);
    },
    setLoggedIn(context) {
      context.commit("loginSuccess");
    },
    login({ dispatch, commit }, { username, password }) {
      commit("loginRequest");
      userService.login(username, password).then(
        user => {
          commit("loginSuccess", user.data);
          if (user.data.userType === 0 || user.data.userType === 2) {
            router.push({ name: "DashboardSeller" });
          } else {
            commit("SET_ADDRESS", user.data.items[0].address);
            router.push({ name: "Huis" });
          }
        },
        error => {
          commit("loginFailure", error);
          if (typeof error.response === 'undefined') {
            dispatch(
              "alert/error",
              "Er is iets misgegaan",
              {
                root: true
              }
            );
          }          
          if (error.response.status === 403) {
            // dispatch("alert/error", error.response.data, { root: true });
            dispatch(
              "alert/error",
              "Aanmelden niet gelukt. Controleer uw gebruikersnaam of wachtwoord",
              {
                root: true
              }
            );
          }
        }
      );
    },
    register({ dispatch, commit, state }, userInfo) {
      const code = state.code;
      commit("registerRequest", userInfo);

      userService
        .register(userInfo, code)
        .then(
          user => {
            commit("registerRequest", user);
            router.push({ path: "/verkoop/created" });
            setTimeout(() => {
              // display success message after route change completes
              dispatch("alert/success", "Registratie successvol", {
                root: true
              });
            });
          },
          error => {
            commit("registerFailure", error);
            dispatch("alert/error", error.response.data.message, {
              root: true
            });
          }
        )
        .catch(error => {
          if (!error.response) {
            // network error
            this.errorStatus = "Error: Network Error";
          } else {
            this.errorStatus = error.response.data.message;
          }
        });
    },
    logout({ commit }) {
      userService.logout();
      commit("logout");
    },
    fetch({ dispatch, commit }) {
      userService.getById().then(
        response => {
          commit("loginSuccess", response.data);
          commit("SET_NAME", response.data.items[0].name);
          commit("SET_ADDRESS", response.data.items[0].address);
          commit("SET_BIDS", response.data.items[0].bids);
          commit("SET_MINIMUMBID", response.data.items[0].minimumPrice);
          commit("SET_HIGHESTBID", response.data.items[0].bids);
          commit("SET_ASSETS", response.data.items[0].assets);
          commit("SET_PERCENTAGE", response.data.items[0].fundaReadyPercentage);
          commit("SET_IMAGE", response.data.items[0].photos);
          commit("SET_FUNDAURL", response.data.items[0].fundaUrl);
          commit("SET_ASSETS", response.data.items[0].assets);
          commit("SET_CLOSINGDATETIME", response.data.items[0].closingDateTime);
        },
        error => {
          dispatch("alert/error", error.response.data.message, {
            root: true
          });
          commit("logout"); // if the request fails, remove any possible user token if possible
          userService.logout();
          router.push({name: "Inloggen"});
        }
      )
    },
    confirm({ dispatch, commit }, confirmToken) {
      userService.confirm(confirmToken).then(
        user => {
          commit("loginSuccess", user.data);
          commit("SET_ADDRESS", user.data.items[0].address);
          router.push({name: "confirmSucces"});
        },
        error => {
          dispatch("alert/error", error.response.data.message, {
            root: true
          });
        }
      );
    },

    submitbid({ dispatch }, bid) {
      return new Promise((resolve, reject) => {
        userService.submitbid(bid).then(
          response => {
            dispatch("alert/success", "Gelukt! uw bod is geplaatst", {
              root: true
            });
            resolve(response);
          },
          error => {
            dispatch("alert/error", error.response.data.message, {
              root: true
            });
            reject(error);
          }
        );
      });
    },

    confirmBid({ dispatch, commit }, confirmBidToken) {
      userService.confirmbid(confirmBidToken).then(
        user => {
          commit("loginSuccess", user.data);
          commit("SET_ADDRESS", user.data.items[0].address);
          commit("SET_MINIMUMBID", user.data.items[0].minimumPrice);
          commit("SET_IMAGE", user.data.items[0].photos);
          router.push("/koop/bodsuccesvol");
        },
        error => {
          dispatch("alert/error", error.response.data.message, {
            root: true
          });
        }
      );
    },
    forgot({ dispatch, commit }, mail) {
      userService.forgot(mail).then(
        user => {
          commit("registerSuccess", user);
          setTimeout(() => {
            // display success message after route change completes
            dispatch("alert/success", "Gelukt! bekijk uw email", {
              root: true
            });
          });
        },
        error => {
          dispatch("alert/error", error.response.data.message, {
            root: true
          });
        }
      );
    },
    changePassword({ dispatch, commit }, { password, changeToken }) {
      userService.changePassword(password, changeToken).then(
        user => {
          commit("loginSuccess", user.data);
          if (user.data.userType === 0 || user.data.userType === 2) {
            router.push({ name: "DashboardSeller" });
          } else {
            commit("SET_ADDRESS", user.data.items[0].address);
            router.push({ name: "Huis" });
          }
        },
        error => {
          dispatch("alert/error", error.response.data.message, {
            root: true
          });
        }
      );
    },
    callme({ dispatch }, { phonenumber }) {
      userService.callMe(phonenumber).then(
        response => {
          dispatch("alert/success", "Gelukt!, wij nemen z.s.m. contact op", {
            root: true
          });
          return response.data.success;
        },
        error => {
          dispatch("alert/error", error.response.data.message, {
            root: true
          });
        }
      );
    },
    getProperty({ dispatch, commit }, { code }) {
      userService.getProperty(code).then(
        response => {
          commit("SET_CODE", code);
          commit("SET_NAME", response.data.items[0].name);
          commit("SET_ADDRESS", response.data.items[0].address);
          commit("SET_BIDS", response.data.items[0].bids);
          commit("SET_MINIMUMBID", response.data.items[0].minimumPrice);
          commit("SET_HIGHESTBID", response.data.items[0].bids);
          commit("SET_ASSETS", response.data.items[0].assets);
          commit("SET_PERCENTAGE", response.data.items[0].fundaReadyPercentage);
          commit("SET_IMAGE", response.data.items[0].photos);
          commit("SET_FUNDAURL", response.data.items[0].fundaUrl);
          commit("SET_ASSETS", response.data.items[0].assets);
          commit("SET_CODECLAIMED", response.data.codeClaimed);
          commit("SET_CLOSINGDATETIME", response.data.items[0].closingDateTime);
          router.push({ name: "Huis"});
        },
        error => {
          dispatch("alert/error", error.response.data.message, {
            root: true
          });
        }
      );
    },
    contact({ dispatch }, { message }) {
      userService.contact(message).then(
        response => {
          dispatch("alert/success", "Gelukt!, wij nemen z.s.m. contact op", {
            root: true
          });
          return response.data.success;
        },
        error => {
          dispatch("alert/error", error.response.data.message, {
            root: true
          });
        }
      );
    }
  },
  mutations: {
    SET_AGENT: (state, agentdata) => {
      state.agent = agentdata;
    },
    SET_PROPERTIES: (state, propertydata) => {
      state.properties = propertydata;
    },
    SET_POSTS: (state, postdata) => {
      state.posts = postdata;
    },
    SET_SUPPORT: (state, postdata) => {
      state.support = postdata;
    },
    SET_REGIO: (state, postdata) => {
      state.regio = postdata;
    },
    SET_REVIEW: (state, postdata) => {
      state.review = postdata;
    },
    SET_Funnel_toelichting: (state, postdata) => {
      state.Funnel_toelichting = postdata;
    },
    SET_IMAGE: (state, images) => {
      if(images) {
        Vue.set(state, 'images', [...images]);
      }
    },
    IS_PLAYING(state, play) {
      state.isPlaying = play;
    },
    IS_OPEN(state, open) {
      state.openModal = open;
    },
    SET_ADDRESS(state, address) {
      Vue.set(state, "address", address);
    },
    SET_NAME(state, name) {
      state.name = name;
    },
    SET_BIDS(state, bids) {
      state.bids = bids;
    },
    SET_MINIMUMBID(state, minbid) {
      state.minbid = minbid;
    },
    SET_HIGHESTBID(state, bids) {
      if(bids != 0) {
        let highest = Number.NEGATIVE_INFINITY;
        let tmp;
        for (let i = bids.length - 1; i >= 0; i -= 1) {
          tmp = bids[i].amount;
          if (tmp > highest) highest = tmp;
        }
        state.highest = highest;
      }
    },
    SET_FUNDAURL(state, url) {
      if(url) {
        state.fundaUrl = url;
      }
    },
    SET_ASSETS(state, assets) {
      state.assets = assets;
    },
    SET_CLOSINGDATETIME(state, closingDateTime) {
      state.closingDateTime = closingDateTime;
    },
    SET_PERCENTAGE(state, percentage) {
      state.percentage = percentage;
    },
    SET_CODE(state, code) {
      state.code = code;
    },
    SET_CODECLAIMED(state, codeClaimed) {
      state.codeClaimed = codeClaimed;
    },
    loginRequest(state) {
      state.status = { loggingIn: true };
    },
    loginSuccess(state, user) {
      state.status = { loggedIn: true };
      state.user = user;
    },
    loginFailure(state) {
      state.status = {};
      state.user = null;
    },
    logout(state) {
      state.status = {loggedIn: false};
      state.user = null;
      state.address = {};
      state.name = null,
      state.minbid = null,
      state.highest = null,
      state.bids = [],
      state.fundaUrl = null,
      state.images = [],
      state.assets = [],
      state.closingDateTime = null,
      state.code = null,
      state.codeClaimed = false,
      state.linkedProperty = null,
      state.percentage = null
    },
    registerRequest(state) {
      state.status = { registering: true };
    },
    registerSuccess(state) {
      state.status = {};
    },
    registerFailure(state) {
      state.status = {};
    }
  },
  getters: {
    getAgent(state) {
      return state.agent;
    },
    getProperties(state) {
      return state.properties;
    },
    getPosts(state) {
      return state.posts;
    },
    getSupport(state) {
      return state.support;
    },
    getRegio(state) {
      return state.regio;
    },
    getReview(state) {
      return state.review;
    },
    getFunnel_toelichting(state) {
      return state.Funnel_toelichting;
    },
    showVideo(state) {
      return state.isPlaying;
    },
    getUserInfo(state) {
      return state.name;
    },
    getAddressInfo(state) {
      return state.address;
    },
    getPercentage(state) {
      return state.percentage;
    },
    getMinimumBid(state) {
      return state.minbid;
    },
    getHighestBid(state) {
      return state.highest ? state.highest : state.minbid;
    },
    loggedIn(state) {
      return state.status.loggedIn;
    },
    getFundaUrl(state) {
      return state.fundaUrl;
    },
    getclosingDateTime(state) {
      return state.closingDateTime + 1;
    },
    getImages(state) {
      return state.images.map(image => ({
        image
      }));
    }
  }
});

export default store;
